<template>
    <div class="FosterFamilyInquiryForm">
        <div class="container">
            <div class="row">
                <div class="col paper center-text">
                    <img :src="HeaderImg" style="width: 100%; max-width: 491px;"/>
                    <h2 style="margin-top:25px;">Caregiver Inquiry</h2>
                    <p v-if="PagePhase == 'Form'">Please fill out your information below and one of our Family Specialists will get in contact with you!</p>
                </div>
            </div>
            <div v-if="PagePhase == 'Form'">
                <b-form @submit="SubmitForm">
                    <div class="row">
                        <div class="col-lg paper">
                            <h4>Your Name(s)</h4>
                            <p class="center-text">Parent 1</p>
                            <div class="form-group">
                                <label>First Name:</label>
                                <input type="text" class="form-control" required v-model="FamilyInfo.Parent1FirstName" />
                            </div>
                            <div class="form-group">
                                <label>Last Name:</label>
                                <input type="text" class="form-control" required v-model="FamilyInfo.Parent1LastName" />
                            </div>
                            <p class="center-text">Parent 2 (if applicable)</p>
                            <div class="form-group">
                                <label>First Name:</label>
                                <input type="text" class="form-control" v-model="FamilyInfo.Parent2FirstName" />
                            </div>
                            <div class="form-group">
                                <label>Last Name:</label>
                                <input type="text" class="form-control" v-model="FamilyInfo.Parent2LastName" />
                            </div>
                        </div>
                        <div class="col-lg paper">
                            <h4>Contact Info</h4>
                            <div class="form-group">
                                <label>Email:</label>
                                <input type="email" class="form-control" required v-model="FamilyInfo.Email" />
                            </div>
                            <div class="form-group">
                                <label>Phone Number:</label>
                                <input type="tel" class="form-control" required v-model="FamilyInfo.Phone" />
                            </div>
                            <div class="form-group">
                                <label>Address:</label>
                                <input type="text" v-model="FamilyInfo.AddressLine1" class="form-control" required placeholder="Address Line 1" />
                                <input type="text" v-model="FamilyInfo.AddressLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                                <input type="text" v-model="FamilyInfo.City" required class="form-control" placeholder="City" />
                                <b-row>
                                    <div class="col-6 no-padding">
                                        <select class="form-control" required v-model="FamilyInfo.StateAbbreviation">
                                            <option v-for="option in StateOptions" :value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-6 no-padding">
                                        <input type="text" v-model="FamilyInfo.ZipCode" class="form-control" required placeholder="Zip" />
                                    </div>
                            </div>
                        </div>
                        <div class="col-lg paper">
                            <h4>Other Info</h4>
                            <div class="form-group">
                                <label>How did you hear about Olive Crest?</label>
                                <select v-model="FamilyInfo.ReferralSource" class="form-control">
                                    <option value="Church">Church</option>
                                    <option value="Olive Crest Family">Olive Crest Family</option>
                                    <option value="Olive Crest Employee">Olive Crest Employee</option>
                                    <option value="A Friend">A Friend</option>
                                    <option value="Internet Search">Internet Search</option>
                                    <option value="County Agency">County Agency</option>
                                    <option value="Other">Other (Describe Below)</option>
                                </select>
                                <textarea v-if="FamilyInfo.ReferralSource == 'Other'" rows="5" class="form-control" placeholder="Describe" v-model="FamilyInfo.ReferralSourceComments" />
                            </div>
                            <div class="form-group">
                                <label>Best Time to Reach {{ PluralChangerUsMe }}:</label>
                                <select v-model="FamilyInfo.Availability" class="form-control">
                                    <option value="Anytime">Anytime</option>
                                    <option value="Weekdays before noon">Weekdays before noon</option>
                                    <option value="Weekdays after 4pm">Weekdays after 4pm</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <button type="submit" class="btn btn-success form-control" style="margin-bottom:25px;">SUBMIT</button>
                        </div>
                    </div>
                </b-form>
            </div>
            <div v-if="PagePhase == 'Confirmation'">
                <div class="row">
                    <div class="col paper">
                        <h4 class="center-text">Information Submitted</h4>
                        <p>Greetings,</p>
                        <p>Thank you for taking the time to request an introduction to Olive Crest here in the Pacific Northwest. Olive Crest transforms the lives of children in crisis through the healing power of God, family, and community. We are happy you are exploring your calling with us.  And, we look forward to supporting you in your journey to serve children and families in crisis.</p>
                        <p>Within the next 24-48 hours you can expect to be contacted by an Olive Crest Family Specialist. Your Family Specialist will schedule a time to chat with you on the phone. We look forward to getting to know you better, and hearing about your inspiration to serve children and families.</p>
                        <p>Thank you again for considering Olive Crest. We hope you are blessed by your experience.</p>
                        <p>Jeff Clare</p>
                        <p>Regional Program Director</p>
                        <p><a href="mailto:jeff-clare@olivecrest.org">Jeff-Clare@olivecrest.org</a></p>
                        <p> </p>
                        <p>Click <a href="https://www.olivecrest.org/what-we-do-strong-families">HERE</a> to return to the Olive Crest home page.</p>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    //import components
    
    export default {
        props: [
            
        ],
        data: function () {
            return {
                FamilyInfo: {
                    Parent1FirstName: "",
                    Parent1LastName: "",
                    Parent2FirstName: "",
                    Parent2LastName: "",
                    Email: "",
                    Phone: "",
                    AddressLine1: "",
                    AddressLine2: "",
                    City: "",
                    StateAbbreviation: "",
                    ZipCode: "",
                    ReferralSource: "",
                },
                HeaderImg: "/images/Olive-Crest-Logo.png",
                PagePhase: "Form",//Form, Confirmation
            };
        },
        methods: {
            SubmitForm(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Foster/FosterInquiry/RecordInquiryPNW", this.FamilyInfo, this.SubmitFormSuccess, () => { }, true);
            },
            SubmitFormSuccess(response) {
                this.PagePhase = "Confirmation";
            }
        },
        components: {
        },
        mounted() { 
            if (this.RegionParam) {
                this.FamilyInfo.Region = this.RegionParam;
            }
        },
        computed: {
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
            RegionParam: function () {
                let RegionVal = this.$route.query.Region;
                if (RegionVal) {
                    return RegionVal;
                } else {
                    return null;
                }
            },
            PluralChangerUsMe: function () {
                if (this.FamilyInfo.Parent2FirstName) {
                    return "us";
                } else {
                    return "me";
                }
            },
        },
    }
</script>

<style scoped>

</style>